import type { OrganizationCustomRoleKey } from "@clerk/nextjs/types"

export const ORGANIZATION_ROLE_LABELS = {
  "org:admin": "Admin",
  "org:member": "Member",
} as const

export type OrganizationRole = keyof typeof ORGANIZATION_ROLE_LABELS

export interface MemberSummary {
  id: string
  name: string
  email: string
  role: OrganizationCustomRoleKey
  joined_at: string
  image_url?: string | null
}

export interface InvitationSummary {
  id: string
  email: string
  role: OrganizationCustomRoleKey
  created_at: string
}

export interface MemberManagementData {
  members: readonly MemberSummary[]
  invitations: readonly InvitationSummary[]
}

export interface MemberManagementActions {
  invite: (
    email: string | readonly string[],
    role: OrganizationRole,
  ) => Promise<void>
  changeRole: (member: MemberSummary, role: OrganizationRole) => Promise<void>
  remove: (member: MemberSummary) => Promise<void>
  revoke: (invitation: InvitationSummary) => Promise<void>
}
